<script lang="ts" setup>
const { $t } = useI18n()

useHead({ title: String($t('components.bitbeli.index.courseTicket')) })
</script>

<template>
  <div fubex-container py-80px>
    <h1 heading1 text-center font-700>
      {{ $t('components.bitbeli.index.courseTicket') }}
    </h1>
    <WidgetExchangeRates />
  </div>
</template>
